import { getCookie } from '../../../shared/helpers/cookie';

const filterPollBuilderQuestionsByLang = (questions, lang) => {
  if (!questions) return null;

  const getLangData = (question, key) => {
    if (!question[key]) return null;

    if (!question[key][lang]) return question[key].ru;

    return question[key][lang];
  };

  return questions.map((question) => {
    const choices = question.choices && question.choices.map((choice) => ({
      id: choice.id && choice.id,
      content: getLangData(choice, 'content'),
    }));

    return {
      id: question.id && question.id,
      title: getLangData(question, 'title'),
      desc: getLangData(question, 'desc'),
      details: getLangData(question, 'details'),
      choices,
    };
  });
};

const filterPollBuilderInitialIds = (questions) => {
  const result = {};
  questions.forEach((question) => {
    result[question.id] = getCookie(question.id) || (question.choices && question.choices[0].id);
  });

  return result;
};

export { filterPollBuilderQuestionsByLang, filterPollBuilderInitialIds };
